/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ETransportAddressDTO } from './etransport-address-dto.model';

export class ETransportNotificationMetadata extends JSONable {

  shipmentStartAddressDTO: ETransportAddressDTO | null = null;
  shipmentEndAddressDTO: ETransportAddressDTO | null = null;
}
